require('./angular-animate');
module.exports = 'ngAnimate';



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-animate/index.js
 ** module id = 16
 ** module chunks = 0
 **/